import { api } from "../client";
import {
  PartialAdditionalI18nFields,
  AdditionalI18nFields,
} from "../schema/AdditionalI18n";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<AdditionalI18nFields>;
type ApiRequestConfigMutate = ConfigMutate<PartialAdditionalI18nFields, []>;

export const getAdditionalI18ns = async (config?: ApiRequestConfig) => {
  return api.get<AdditionalI18nFields>("additional_i18ns", config);
};
export const getAdditionalI18n = (id: number, config?: ApiRequestConfig) => {
  return api.get<AdditionalI18nFields>(`additional_i18ns/${id}`, config);
};

export const createAdditionalI18n = (config: ApiRequestConfigMutate) => {
  return api.create<PartialAdditionalI18nFields>("additional_i18ns", config);
};
export const updateAdditionalI18n = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialAdditionalI18nFields>(
    `additional_i18ns/${id}`,
    config
  );
};
export const deleteAdditionalI18n = (id: number) => {
  return api.remove<AdditionalI18nFields>(`additional_i18ns/${id}`);
};
